export const IMAGE_RESOLUTION_PRESETS = [
	{
		ratio: '21:9',
		resolutions: {
			'1K': '1024x448',
			'1.5K': '1536x672',
			'2K': '2368x1024',
			'3K': '3072x1344',
			'4K': '4096x1792',
			'seedream-v5.0-lite': '3024x1296',
			'standard': '1512x648',
			'z-image-turbo': '2016*864',
			'z-image-turbo-1024': '1344*576',
			'seedream-4.0-1K': '1512x648',
			'seedream-4.0-2K': '3136x1344',
			'seedream-4.0-4K': '6240x2656',
			'seedream-4.5-2K': '3136x1344',
			'seedream-4.5-4K': '6240x2656',
			'seedream-5.0-1K': '1568x672',
			'seedream-5.0-2K': '3136x1344',
			'seedream-5.0-3K': '4704x2016',
			'seedream-5.0-4K': '6240x2656',
			'wan-2.7': '3136*1344',
			'wan-2.7-1K': '1952*832',
			'wan-2.7-2K': '3136*1344',
			'wan-2.7-4K': '4096*1760',
			'qwen-image-max': '1344*576',
			'qwen-image-plus': '1344*576',
		}
	},
	{
		ratio: '16:9',
		resolutions: {
			'1K': '1024x576',
			'1.5K': '1536x864',
			'2K': '2048x1152',
			'3K': '3072x1728',
			'4K': '4096x2304',
			'seedream-v5.0-lite': '2560x1440',
			'standard': '1280x720',
			'wan': '1696*960',
			'z-image-turbo': '2048*1152',
			'z-image-turbo-1024': '1280*720',
			'wan-2.7': '2688*1536',
			'wan-2.7-1K': '1696*960',
			'wan-2.7-2K': '2688*1536',
			'wan-2.7-4K': '4096*2304',
			'seedream-4.0-1K': '1280x720',
			'seedream-4.0-2K': '2848x1600',
			'seedream-4.0-4K': '5504x3040',
			'seedream-4.5-2K': '2848x1600',
			'seedream-4.5-4K': '5504x3040',
			'seedream-5.0-1K': '1312x736',
			'seedream-5.0-2K': '2848x1600',
			'seedream-5.0-3K': '4096x2304',
			'seedream-5.0-4K': '5504x3040',
			'qwen-image-max': '1280*720',
			'qwen-image-plus': '1280*720',
		}
	},
	{
		ratio: '9:16',
		resolutions: {
			'1K': '576x1024',
			'1.5K': '864x1536',
			'2K': '1152x2048',
			'3K': '1728x3072',
			'4K': '2304x4096',
			'seedream-v5.0-lite': '1440x2560',
			'standard': '720x1280',
			'wan': '960*1696',
			'z-image-turbo': '1152*2048',
			'z-image-turbo-1024': '720*1280',
			'wan-2.7': '1536*2688',
			'wan-2.7-1K': '960*1696',
			'wan-2.7-2K': '1536*2688',
			'wan-2.7-4K': '2304*4096',
			'seedream-4.0-1K': '720x1280',
			'seedream-4.0-2K': '1600x2848',
			'seedream-4.0-4K': '3040x5504',
			'seedream-4.5-2K': '1600x2848',
			'seedream-4.5-4K': '3040x5504',
			'seedream-5.0-1K': '736x1312',
			'seedream-5.0-2K': '1600x2848',
			'seedream-5.0-3K': '2304x4096',
			'seedream-5.0-4K': '3040x5504',
			'qwen-image-max': '720*1280',
			'qwen-image-plus': '720*1280',
		}
	},
	{
		ratio: '1:1',
		resolutions: {
			'1K': '1024x1024',
			'1.5K': '1536x1536',
			'2K': '2048x2048',
			'3K': '3072x3072',
			'4K': '4096x4096',
			'seedream-v5.0-lite': '2048x2048',
			'standard': '1024x1024',
			'wan': '1280*1280',
			'z-image-turbo': '1536*1536',
			'z-image-turbo-1024': '1024*1024',
			'wan-2.7': '2048*2048',
			'wan-2.7-1K': '1280*1280',
			'wan-2.7-2K': '2048*2048',
			'wan-2.7-4K': '4096*4096',
			'seedream-4.0-1K': '1024x1024',
			'seedream-4.0-2K': '2048x2048',
			'seedream-4.0-4K': '4096x4096',
			'seedream-4.5-2K': '2048x2048',
			'seedream-4.5-4K': '4096x4096',
			'seedream-5.0-1K': '1024x1024',
			'seedream-5.0-2K': '2048x2048',
			'seedream-5.0-3K': '3072x3072',
			'seedream-5.0-4K': '4096x4096',
			'qwen-image-max': '1024*1024',
			'qwen-image-plus': '1024*1024',
		}
	},
	{
		ratio: '2:3',
		resolutions: {
			'1K': '688x1024',
			'1.5K': '1032x1536',
			'2K': '1376x2048',
			'3K': '2048x3072',
			'4K': '2752x4096',
			'seedream-v5.0-lite': '1664x2496',
			'standard': '832x1216',
			'z-image-turbo': '1248*1872',
			'z-image-turbo-1024': '832*1248',
			'wan-2.7': '1680*2512',
			'wan-2.7-1K': '1040*1568',
			'wan-2.7-2K': '1680*2512',
			'wan-2.7-4K': '2736*4096',
			'seedream-4.0-1K': '832x1248',
			'seedream-4.0-2K': '1664x2496',
			'seedream-4.0-4K': '3328x4992',
			'seedream-4.5-2K': '1664x2496',
			'seedream-4.5-4K': '3328x4992',
			'seedream-5.0-1K': '832x1248',
			'seedream-5.0-2K': '1664x2496',
			'seedream-5.0-3K': '2496x3744',
			'seedream-5.0-4K': '3328x4992',
			'qwen-image-max': '768*1152',
			'qwen-image-plus': '768*1152',
		}
	},
	{
		ratio: '3:2',
		resolutions: {
			'1K': '1024x688',
			'1.5K': '1536x1032',
			'2K': '2048x1376',
			'3K': '3072x2048',
			'4K': '4096x2752',
			'seedream-v5.0-lite': '2496x1664',
			'standard': '1216x832',
			'z-image-turbo': '1872*1248',
			'z-image-turbo-1024': '1248*832',
			'wan-2.7': '2512*1680',
			'wan-2.7-1K': '1568*1040',
			'wan-2.7-2K': '2512*1680',
			'wan-2.7-4K': '4096*2736',
			'seedream-4.0-1K': '1248x832',
			'seedream-4.0-2K': '2496x1664',
			'seedream-4.0-4K': '4992x3328',
			'seedream-4.5-2K': '2496x1664',
			'seedream-4.5-4K': '4992x3328',
			'seedream-5.0-1K': '1248x832',
			'seedream-5.0-2K': '2496x1664',
			'seedream-5.0-3K': '3744x2496',
			'seedream-5.0-4K': '4992x3328',
			'qwen-image-max': '1152*768',
			'qwen-image-plus': '1152*768',
		}
	},
	{
		ratio: '3:4',
		resolutions: {
			'1K': '768x1024',
			'1.5K': '1152x1536',
			'2K': '1536x2048',
			'3K': '2304x3072',
			'4K': '3072x4096',
			'seedream-v5.0-lite': '1728x2304',
			'standard': '864x1152',
			'wan': '1104*1472',
			'z-image-turbo': '1296*1728',
			'z-image-turbo-1024': '864*1152',
			'wan-2.7': '1728*2368',
			'wan-2.7-1K': '1104*1472',
			'wan-2.7-2K': '1728*2368',
			'wan-2.7-4K': '3072*4096',
			'seedream-4.0-1K': '864x1152',
			'seedream-4.0-2K': '1728x2304',
			'seedream-4.0-4K': '3520x4704',
			'seedream-4.5-2K': '1728x2304',
			'seedream-4.5-4K': '3520x4704',
			'seedream-5.0-1K': '864x1152',
			'seedream-5.0-2K': '1728x2304',
			'seedream-5.0-3K': '2592x3456',
			'seedream-5.0-4K': '3520x4704',
			'qwen-image-max': '960*1280',
			'qwen-image-plus': '960*1280',
		}
	},
	{
		ratio: '4:3',
		resolutions: {
			'1K': '1024x768',
			'1.5K': '1536x1152',
			'2K': '2048x1536',
			'3K': '3072x2304',
			'4K': '4096x3072',
			'seedream-v5.0-lite': '2304x1728',
			'standard': '1152x864',
			'wan': '1472*1104',
			'z-image-turbo': '1728*1296',
			'z-image-turbo-1024': '1152*864',
			'wan-2.7': '2368*1728',
			'wan-2.7-1K': '1472*1104',
			'wan-2.7-2K': '2368*1728',
			'wan-2.7-4K': '4096*3072',
			'seedream-4.0-1K': '1152x864',
			'seedream-4.0-2K': '2304x1728',
			'seedream-4.0-4K': '4704x3520',
			'seedream-4.5-2K': '2304x1728',
			'seedream-4.5-4K': '4704x3520',
			'seedream-5.0-1K': '1152x864',
			'seedream-5.0-2K': '2304x1728',
			'seedream-5.0-3K': '3456x2592',
			'seedream-5.0-4K': '4704x3520',
			'qwen-image-max': '1280*960',
			'qwen-image-plus': '1280*960',
		}
	},
	{
		ratio: '7:9',
		resolutions: {
			'z-image-turbo': '1344*1728',
			'z-image-turbo-1024': '896*1152',
			'wan-2.7': '1808*2320',
			'wan-2.7-1K': '1136*1456',
			'wan-2.7-2K': '1808*2320',
			'wan-2.7-4K': '3184*4096',
		}
	},
	{
		ratio: '9:7',
		resolutions: {
			'z-image-turbo': '1728*1344',
			'z-image-turbo-1024': '1152*896',
			'wan-2.7': '2320*1808',
			'wan-2.7-1K': '1456*1136',
			'wan-2.7-2K': '2320*1808',
			'wan-2.7-4K': '4096*3184',
		}
	},
	{
		ratio: '4:5',
		resolutions: {
			'1K': '832x1024',
			'1.5K': '1248x1536',
			'2K': '1664x2048',
			'3K': '2496x3072',
			'4K': '3264x4096',
			'standard': '1152x1440',
		}
	},
	{
		ratio: '5:4',
		resolutions: {
			'1K': '1024x832',
			'1.5K': '1536x1248',
			'2K': '2048x1664',
			'3K': '3072x2496',
			'4K': '4096x3264',
			'standard': '1440x1152'
		}
	},
	{
		ratio: '9:21',
		resolutions: {
			'z-image-turbo': '864*2016',
			'z-image-turbo-1024': '576*1344',
			'wan-2.7': '1344*3136',
			'wan-2.7-1K': '832*1952',
			'wan-2.7-2K': '1344*3136',
			'wan-2.7-4K': '1760*4096',
		}
	},
];